import React, { Component } from "react";
import axios from "axios";
import { API_URL } from "src/scenes/App";
import Renewal from "./forms/Renewal";
import RenewalSuccess from "./forms/RenewalSuccess";
import {
    Toast, PageContainer
} from "src/components";
import { SubscriptionRenewalContext } from "./SubscriptionRenewalContext";
import SubscriptionCostResponse from "src/scenes/Subscription/api/SubscriptionCostResponse";

import { UserContext } from "src/scenes/App/UserContext";
import { SubscriptionMode, UserKeys } from "src/constants/userDetails";
import * as PERMISSIONS from "src/constants/permissions";
import { withRouter } from "react-router-dom";

export const RenewalForms = {
    RENEWAL: 1,
    RENEWAL_SUCCESS: 2,
};

class SubscriptionRenewal extends Component {
    static contextType = UserContext;
    
    state = {
        loadingCount: 1,
        currentForm: RenewalForms.RENEWAL,
        totalNumber: 0,
        costing: SubscriptionCostResponse.default(),
        hasBillingPermission: false,
        isPurchasingMoreUsers: false,
        isSubscriptionExpired: false,
        currentSubscription: null
    };
    
    //we just provide a return url from PayPal and this local storage will help us to determine which
    //page the front-end should display to the user correctly.
    async componentDidMount() {
        if (this.context) {
            const { permissions } = this.context;
            /** check if user has Billing permission
             * this will prevent 403s when user doesnt have billing permission */
            
            const hasBillingPermission = PERMISSIONS.hasPermissions([PERMISSIONS.BILLING], permissions);
        
            this.setState({ hasBillingPermission });
            await this.getCompanyAndCheckForExpiry();
        
            if (hasBillingPermission) {
                await this.loadSubscriptionCost();
            }
        }

        this.setState((prevState) => ({ loadingCount: prevState.loadingCount - 1 })); // initialized state.loadingCount as 1
    }
    
    redirectToActive = () => {
        this.props.history.push("/active");
    };

    getCompanyAndCheckForExpiry = async () => {
        this.setState((prevState) => ({ loadingCount: prevState.loadingCount + 1 }));
    
        try {
            const response = await axios.get(`${API_URL}/company`, {
                headers: {
                    Authorization: `Bearer ${this.context.token}`,
                },
            });
    
            const { mode, currentSubscription, totalNumber } = response.data;
            let isSubscriptionExpired = false;
            if (mode === SubscriptionMode.ACTIVE) {
                isSubscriptionExpired = !currentSubscription || (currentSubscription.isExpired || currentSubscription.periodsDue > 0);
            }

            if (!isSubscriptionExpired) {
                Toast.error("Your account is still active, redirecting to dashboard");
                this.redirectToActive();
                return;
            }
    
            this.setState({
                totalNumber: totalNumber,
                isSubscriptionExpired: isSubscriptionExpired,
                currentSubscription: currentSubscription
            });
        } catch (error) {
            Toast.error(error.getApiErrorDetails().message);
        } finally {
            this.setState((prevState) => ({ loadingCount: prevState.loadingCount - 1 }));
        }
    };

    loadSubscriptionCost = async () => {
        this.setState((prevState) => ({ loadingCount: prevState.loadingCount + 1 }));
        try {
            const costing = await SubscriptionCostResponse.get(this.context.token);
            this.setState({
                costing: costing
            });
        } catch (error) {
            console.error("Failed loading subscription cost:", error);
        } finally {
            this.setState((prevState) => ({ loadingCount: prevState.loadingCount - 1 }));
        }
    };

    nextClick = async () => {
        await this.context.appFns.reinitialiseUser();
        this.setState({
            currentForm: RenewalForms.RENEWAL_SUCCESS
        });
    };

    render() {
        const userContext = this.context;
        const { loadingCount, currentForm, totalNumber,
            costing, moreUsers, currentSubscription } = this.state;
        const isRenewalForm = currentForm === RenewalForms.RENEWAL;

        return (
            <PageContainer
                height={isRenewalForm ? "calc(100vh - 64px)" : undefined}
                overflow={isRenewalForm ? "hidden" : undefined}
            >
                <SubscriptionRenewalContext.Provider value={{
                    loadingCount: loadingCount,

                    email: userContext.email,
                    token: userContext.token,
                    nextClick: this.nextClick,

                    //Renewal > Plan
                    totalNumber: totalNumber,
                    companyName: userContext[UserKeys.COMPANY_NAME], 
                    moreUsers: moreUsers,
                    currentSubscription: currentSubscription,
                    currentForm: currentForm,
                    costing: costing,

                    //RenewalSuccess
                    abn: userContext[UserKeys.COMPANY_ABN],
                    country: userContext[UserKeys.COUNTRY_CODE]
                }}>
                    { currentForm === RenewalForms.RENEWAL &&
                        <Renewal /> }
                    { currentForm === RenewalForms.RENEWAL_SUCCESS &&
                        <RenewalSuccess /> }
                </SubscriptionRenewalContext.Provider>
            </PageContainer>
        );
    }
}

export default withRouter(SubscriptionRenewal);
